module.exports = __webpack_public_path__ + "img/id.dab30adb.svg";